import {useCallback, useEffect} from 'react'
import {useDispatch} from 'redux-react-hook'
import ApiSdk from 'services/callApi'
import {orders as ordersAction, orderHistoryLoadedAll as orderHistoryLoadedAllAction} from 'actions'
import useOrderHistory from './useOrderHistory'
import useOpenFutureStatus from './useOpenFutureStatus'

const LIMIT = 10
let curPage = 1

function useOrderHistoryDataProvider (isLogin, symbol, start, end, isFocus, symbolInfo) {
  const dispatch = useDispatch()
  const {data: loadedOrderHistories, hasMore} = useOrderHistory(symbolInfo)
  const ifOpenFuture = useOpenFutureStatus()
  const fetchData = useCallback(
    async () => {
      if (isLogin && ifOpenFuture) {
        const {orderHistories} = await ApiSdk.futures.getOrderHistory(
          {
            symbol,
            startTime: start,
            endTime: end,
            page: curPage,
          },
          true
        )
        if (orderHistories) {
          if (Object.keys(orderHistories).length < LIMIT) {
            dispatch(orderHistoryLoadedAllAction())
          } else {
            dispatch(orderHistoryLoadedAllAction(true))
          }
          dispatch(ordersAction({orderHistories}))
        } else {
          dispatch(orderHistoryLoadedAllAction())
        }
      }
    },
    [isLogin, ifOpenFuture, symbol, start, end, dispatch]
  )

  const loadMore = useCallback(() => {
    if (!hasMore) return Promise.resolve()
    curPage++
    return fetchData()
  }, [fetchData, hasMore])

  useEffect(() => {
    if (isFocus) {
      curPage = 1
      dispatch(ordersAction({orderHistories: {}}))
      fetchData()
    }
  }, [dispatch, fetchData, isFocus])

  return {
    data: loadedOrderHistories,
    fetchData,
    loadMore,
    hasMore
  }
}

export default useOrderHistoryDataProvider
